// @ts-nocheck
import Vue from 'vue'
import ObjectApi from '@/misc/apis/ObjectApi'
import JSZip from 'jszip'
import { mapActions } from 'vuex'
import { saveAs } from 'file-saver'

const contract = {
  data() {
    return {
      blobs: [],
      renderId: '',
      isOnLoad: false,
      numberBriefButler: '-'
    }
  },
  computed: {
    getNumberBriefButler() {
      return this.numberBriefButler
    }
  },
  methods: {
    ...mapActions('contract', ['loadBriefButlerCounts']),
    setNumberBriefButler(numberBriefButler) {
      this.numberBriefButler = numberBriefButler
    },
    async countBriefButler() {
      this.numberBriefButler = await this.loadBriefButlerCounts()
    },
    parseRenderIdMeta(renderIdWithMeta) {
      if (typeof renderIdWithMeta !== 'string' || !renderIdWithMeta) {
        return { name: '', enforcePdf: false }
      }
      const meta = renderIdWithMeta.substring(renderIdWithMeta.indexOf('_') + 1)
      const parts = meta.split('-/-')
      return { name: parts[0] || '', enforcePdf: parts[1] === 'true' }
    },
    normalizeRenderIdEntries(raw) {
      const list = Array.isArray(raw) ? raw : []
      return list
        .map(x => {
          if (typeof x === 'string' && x.length > 0) {
            return { renderId: x }
          }
          if (x && typeof x.renderId === 'string' && x.renderId.length > 0) {
            return x
          }
          return null
        })
        .filter(Boolean)
    },
    getRenderStatus() {
      if (this.isOnLoad || !localStorage) {
        return
      }
      const rawValue = localStorage.getItem('renderId')
      if (!rawValue) {
        return
      }
      let parsed
      try {
        parsed = JSON.parse(rawValue)
      } catch (error) {
        console.error(error)
        localStorage.removeItem('renderId')
        return
      }
      const contracts = this.normalizeRenderIdEntries(parsed)
      if (contracts.length === 0) {
        localStorage.removeItem('renderId')
        return
      }
      this.isOnLoad = true
      const renderIdsFormated = contracts.map(x => x.renderId.split('_')[0])
      let allEntries = contracts
      ObjectApi.listRenderStatus(renderIdsFormated)
        .then((response: any) => {
          const stillInProgress = response.status.filter(function(v) {
            return v.finished === false && v.failed === false
          })
          if (stillInProgress.length === 0) {
            const isFinished = response.status.every(function (v) {
              return v.finished !== false || v.failed !== false
            })
            if (isFinished) {
              const onlyFinished = response.status.filter(x => x.finished)
              const onlyFailed = response.status.filter(x => x.failed)
              if (onlyFailed.length > 0) {
                localStorage.removeItem('renderId')
                this.isOnLoad = false
                onlyFailed.forEach(item => {
                  const contract = contracts.find(x => x.renderId.includes(item.renderId))?.contract
                  if (contract) {
                    Vue.toasted.show(this.$t('message.savingErrors.contractFailed', { templateName: contract.title, error: item.errorMessage }), { type: 'error' })
                  }
                })
              } else if (onlyFinished.length > 9) {
                ObjectApi.getRenderFiles(onlyFinished.map(x => x.renderId))
                  .then((element: any) => {
                    const binary = window.atob(element.contract)
                    const len = binary.length
                    const buffer = new ArrayBuffer(len)
                    const view = new Uint8Array(buffer)
                    for (let i = 0; i < len; i++) {
                      view[i] = binary.charCodeAt(i)
                    }
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(new Blob([view]))
                    link.download = 'Dokumente.zip'
                    link.click()

                    localStorage.removeItem('renderId')
                  })
                  .catch((error: any) => {
                    console.error(error)
                    localStorage.removeItem('renderId')
                    Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateOrderError'), { type: 'error' })
                  })
                  .finally(() => {
                    this.isOnLoad = false
                  })
              } else {
                renderIdsFormated.forEach(e => {
                  const entry = allEntries.find(w => w.renderId.startsWith(e))
                  const { name: renderContractName, enforcePdf } = this.parseRenderIdMeta(entry?.renderId)
                  ObjectApi.getRenderFile(e)
                    .then((element: any) => {
                      // decode base64 string
                      const binary = window.atob(element.contract)
                      const len = binary.length
                      const buffer = new ArrayBuffer(len)
                      const view = new Uint8Array(buffer)
                      for (let i = 0; i < len; i++) {
                        view[i] = binary.charCodeAt(i)
                      }
                      let blob = ''
                      // create the blob object with content-type "application/vnd.openxmlformats-officedocument.wordprocessing"
                      if (enforcePdf) {
                        blob = new Blob([view], { type: 'application/pdf' })
                      } else {
                        blob = new Blob([view], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
                      }
                      const link = document.createElement('a')
                      link.href = window.URL.createObjectURL(blob)
                      link.download = renderContractName + (enforcePdf ? '.pdf' : '.docx')
                      link.click()

                      allEntries = allEntries.filter(b => !b.renderId.startsWith(e))
                      if (allEntries.length > 0) {
                        localStorage.setItem('renderId', JSON.stringify(allEntries))
                      } else {
                        this.isOnLoad = false
                        localStorage.removeItem('renderId')
                      }
                    })
                    .catch((error: any) => {
                      this.isOnLoad = false
                      console.error(error)
                      localStorage.removeItem('renderId')
                      Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateOrderError'), { type: 'error' })
                    })
                })
              }
            }
          } else {
            this.isOnLoad = false
          }
        })
        .catch((error: any) => {
          this.isOnLoad = false
          console.error(error)
          localStorage.removeItem('renderId')
          Vue.toasted.show(this.$t('message.applicationForm.creditTrust.certificateOrderError'), { type: 'error' })
        })
    },
    pack(blobs) {
      const zip = new JSZip()
      const fileName = this.contractTemplateSelected.length === 1 && this.contractTemplate.filter(x => x.id === this.contractTemplateSelected[0]).length ? this.contractTemplate.filter(x => x.id === this.contractTemplateSelected[0])[0].title : 'Dokumente'
      const folder = zip.folder(fileName)
      const alreadyAddedNames = []
      blobs.forEach((blob) => {
        if (alreadyAddedNames.includes(blob.name)) {
          let index = 2
          let newName = blob.name
          do {
            newName = blob.name + '_' + index.toString()
            index++
          } while (alreadyAddedNames.includes(newName))

          folder.file(newName, blob)
          alreadyAddedNames.push(newName)
        } else {
          folder.file(blob.name, blob)
          alreadyAddedNames.push(blob.name)
        }
      })
      zip.generateAsync({ type: 'blob' }).then(function(content) {
        // see FileSaver.js
        saveAs(content, fileName + '.zip')
      })
    }
  }
}

export { contract }
